import { useEffect, useState } from 'react'
import { getHomeData, type HomeData } from '@/lib/api'

export function useHomeData() {
  const [homeData, setHomeData] = useState<HomeData | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let mounted = true
    setLoading(true)
    getHomeData()
      .then((data) => {
        if (!mounted) return
        if (data) {
          setHomeData(data)
          setError(null)
        } else {
          setError('Failed to load homepage')
        }
      })
      .catch((err) => {
        if (!mounted) return
        setError(err instanceof Error ? err.message : 'Failed to load homepage')
      })
      .finally(() => {
        if (mounted) setLoading(false)
      })
    return () => {
      mounted = false
    }
  }, [])

  return { homeData, loading, error }
}
